<template>
    <button class="bg-[#797979] text-base rounded-sm py-4 w-full text-white font-semibold hover:bg-[#5b5b5b]" @click="openReportModal">{{ $t('page.report') }}</button>
</template>


<script>
export default {
  methods: {
    openReportModal(){
      if (this.$store.authStatus){
          this.$store.modals.reportModal = true
        }else{
            this.$store.loginModal = true
        }
    }
  }
};
</script>